import React from "react";
import { AuthProvider } from "context/AuthContext";
import { AlertProvider } from "context/AlertContext";
import AppRoutes from "./routes";

const MainRoutes = () => {
  return (
    <AuthProvider>
      <AlertProvider>
        <AppRoutes />
      </AlertProvider>
    </AuthProvider>
  );
};

export default MainRoutes;
